export default {
  CREATE_SELF_CODE_BANNERS: 'create self-code banners',
  CREATE_SELF_CODE_INTERSTITIALS: 'create self-code interstitials',
  USE_SENSITIVE_TARGETS: 'use sensitive targets',
  MANAGE_CAMPAIGN_SITE_TARGET: 'manage campaign site target'
}
